export default {
    baseStyle: {
        pricingOuterContainer: {
            w: '100%',
            flexDirection: 'column',
            gap: {base: 'xxxsmall.base', md: 'xxxsmall.md', lg: 'xxxsmall.lg', xl: 'xxxsmall.xl'},
        },
        pricingInnerContainer: {
            flexDirection: 'row',
            gap: {base: 'xxxsmall.base', md: 'xxxsmall.md', lg: 'xxxsmall.lg', xl: 'xxxsmall.xl'},
            alignItems: 'center',
            justifyContent: 'flex-start',
            w: '100%',
        },
        currentPrice: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        listPrice: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.subtle',
        },
        discount: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.subtle',
        },
    },
    variants: {
        'cart-product-item': {
            pricingInnerContainer: {
                justifyContent: {base: 'flex-start', lg: 'flex-end'},
            },
        },
    },
}
